import { Box, Skeleton, styled } from '@creditas-ui/react'
import React from 'react'

const CardFeedStyle = styled(Box)`
  background-color: ${({ theme }) => theme.colors.neutral[10]};
  border-radius: 4px;
  min-width: 320px;
  min-height: 252px;
  width: 100%;

  @media screen and (980px) {
    max-width: 432px;
  }
`

const CardFeed = ({ children, loading, ...props }) => {
  return loading ? (
    <Skeleton color="light" height={252} width="100%" />
  ) : (
    <CardFeedStyle component="div" {...props}>
      {children}
    </CardFeedStyle>
  )
}

export { CardFeed }
